import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { AccessCodeService } from '../access-code.service';
import { AccessCode } from '../access-code';

@Component({
    selector: 'app-access-code',
    templateUrl: './access-code.component.html',
    styleUrls: ['./access-code.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class AccessCodeComponent implements OnInit {
	accessTypes: any[]=[];
	lockLocations: any[] = [];
	reservationId: any;
	reservation: any;
	accessStatuses: any[]=[];

	constructor(
		private primengConfig: PrimeNGConfig,
		private accessCodeService: AccessCodeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private el: ElementRef,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.accessCode = data.accessCode,
			this.reservationId = data.reservationId,
			this.reservation = data.reservation,
			this.statuses = accessCodeService.statuses;
			this.accessTypes = accessCodeService.accessTypes;
			this.accessStatuses = accessCodeService.accessStatuses;
			this.lockLocations = accessCodeService.lockLocations;
	}

	@Input() accessCode: AccessCode;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	accessCodeId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	startMinDate: Date = new Date();
	endMinDate: Date | null = null;

	validationMessages = {
		'accessCodeId': [],
		'accessCode': [
			{ type: 'required', message: 'Required' }],
		'startDatePart': [
			{ type: 'required', message: 'Required' }],
		'startTimePart': [],
		'endDatePart': [
			{ type: 'required', message: 'Required' }],
		'endTimePart': [],
		'accessType': [],
		'lockLocation': [],
		'doorName': [],
		'logger': [],
		'shortTermRentalId': [],
		'reservationId': [],
		kabaStatus:[],
	};
	private static readonly defaultStartTime = { h: 16, m: 0 };
	private static readonly defaultEndTime = { h: 11, m: 0 };


	ngOnInit() {
		this.primengConfig.ripple = true;

		const matContainer = this.el.nativeElement.closest('.mat-dialog-container') as HTMLElement;
		if (matContainer) {
			matContainer.style.overflow = 'visible';
		}

		this.formBuild();

		if (this.accessCode != null && this.accessCode.accessCodeId != null) {
			this.startMinDate = new Date(2000, 0, 1);
			this.startMinDate.setHours(0, 0, 0, 0);
		} else {
			this.startMinDate.setHours(0, 0, 0, 0);
		}
		this.endMinDate = this.startMinDate;

		if (this.accessCode) {
			this.accessCodeId = this.accessCode.accessCodeId;
			this.fixDates();
			const startSplit = this.splitDatetime(this.accessCode.startDate, 'start');
			const endSplit   = this.splitDatetime(this.accessCode.endDate, 'end');
			this.form1.patchValue({
				...this.accessCode,
				startDatePart: startSplit.datePart,
				startTimePart: startSplit.timePart,
				endDatePart:   endSplit.datePart,
				endTimePart:   endSplit.timePart,
			});

			if (startSplit.datePart) {
				const d = new Date(startSplit.datePart);
				d.setHours(0, 0, 0, 0);
				this.endMinDate = d;
			}
		}
	}

	onStartDatePartSelect(event: Date | null): void {
		if (!event) {
			this.endMinDate = this.startMinDate;
			return;
		}
		const d = new Date(event);
		d.setHours(0, 0, 0, 0);
		this.endMinDate = d;

		const currentEnd = this.form1.get('endDatePart')?.value as Date | null;
		if (currentEnd && currentEnd < d) {
			this.form1.patchValue({ endDatePart: d });
		}
	}

	
	private splitDatetime(val: any, which: 'start' | 'end'): { datePart: Date | null; timePart: Date | null } {
		if (!val) {
			return { datePart: null, timePart: null };
		}
		const def = which === 'start' ? AccessCodeComponent.defaultStartTime : AccessCodeComponent.defaultEndTime;

		if (typeof val === 'string') {
			const trimmed = val.trim();

			const dateOnly = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
			if (dateOnly) {
				const y = +dateOnly[1];
				const mo = +dateOnly[2] - 1;
				const d = +dateOnly[3];
				const datePart = new Date(y, mo, d, 0, 0, 0, 0);
				const timePart = new Date(y, mo, d, def.h, def.m, 0, 0);
				return { datePart, timePart };
			}

			const m = trimmed.match(
				/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/i
			);
			if (m) {
				const y = +m[1];
				const mo = +m[2] - 1;
				const d = +m[3];
				const datePart = new Date(y, mo, d, 0, 0, 0, 0);
				const hh = +m[4];
				const mi = +m[5];
				const ss = m[6] != null ? +m[6] : 0;
				const timePart = new Date(y, mo, d, hh, mi, ss, 0);
				return { datePart, timePart };
			}

			const prefix = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
			if (prefix) {
				const y = +prefix[1];
				const mo = +prefix[2] - 1;
				const d = +prefix[3];
				const datePart = new Date(y, mo, d, 0, 0, 0, 0);
				const timePart = new Date(y, mo, d, def.h, def.m, 0, 0);
				return { datePart, timePart };
			}
		}
		if (val instanceof Date && !isNaN(val.getTime())) {
			const datePart = new Date(val.getFullYear(), val.getMonth(), val.getDate(), 0, 0, 0, 0);
			return { datePart, timePart: new Date(val) };
		}
		const mom = moment(val);
		if (!mom.isValid()) {
			return { datePart: null, timePart: null };
		}
		const d = mom.toDate();
		return {
			datePart: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0),
			timePart: d
		};
	}

	private combineDateAndTime(datePart: Date | null, timePart: Date | null): string | null {
		if (!datePart) {
			return null;
		}
		const y = datePart.getFullYear();
		const mo = String(datePart.getMonth() + 1).padStart(2, '0');
		const d = String(datePart.getDate()).padStart(2, '0');
		const th = timePart ? timePart.getHours() : 0;
		const tm = timePart ? timePart.getMinutes() : 0;
		const ts = timePart ? timePart.getSeconds() : 0;
		const hh = String(th).padStart(2, '0');
		const mm = String(tm).padStart(2, '0');
		const ss = String(ts).padStart(2, '0');
		return `${y}-${mo}-${d}T${hh}:${mm}:${ss}`;
	}

	private buildPayloadForApi(formValue: any): any {
		const { startDatePart, startTimePart, endDatePart, endTimePart, ...rest } = formValue;
		return {
			...rest,
			startDate: this.combineDateAndTime(startDatePart, startTimePart),
			endDate:   this.combineDateAndTime(endDatePart,   endTimePart),
		};
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.accessCodeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			const payload = this.buildPayloadForApi(this.form1.value);
			console.log('property-add post: ' + JSON.stringify(payload));
			this.formLoading = true;
			this.accessCodeService.add(payload)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.accessCode = res.data.accessCode;
						this.doAdd.emit(this.accessCode);
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may have
						// already saved the access code. Keep formLoading=true to block re-submit
						// until the user reloads. The error interceptor surfaces a warning.
						console.log('accessCode-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.formLoading = false;
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('accessCode: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			const payload = this.buildPayloadForApi(this.form1.value);

			this.accessCodeService.update(payload)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.accessCode = res.data.accessCode;
						this.doUpdate.emit(this.accessCode);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.accessCodeService.delete(this.accessCode.accessCodeId)
				.subscribe(
					(res: any) => {
						console.log('accessCode-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.accessCode);
					},
					(err: any) => {
						console.log('accessCode-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		const defaultStartTime = new Date(); defaultStartTime.setHours(16, 0, 0, 0);
		const defaultEndTime   = new Date(); defaultEndTime.setHours(11, 0, 0, 0);

		this.form1 = this.formBuilder.group({
			accessCodeId:  [this.accessCodeId],
			accessCode:    ['', Validators.required],
			startDatePart: [null, Validators.required],
			startTimePart: [defaultStartTime],
			endDatePart:   [null, Validators.required],
			endTimePart:   [defaultEndTime],
			accessType:    [],
			lockLocation:  [3, Validators.required],
			doorName:      [],
			logger:        [],
			shortTermRentalId: [this.reservation?.shortTermRental?.shortTermRentalId],
			reservationId: [this.reservationId],
			kabaStatus:    [],
		});
	}

	fixDates() {
		const v = this.accessCode?.accessCodeDate as any;
		if (v == null || v === '') {
			return;
		}
		if (typeof v === 'string') {
			const m = v.match(/^(\d{4})-(\d{2})-(\d{2})/);
			if (m) {
				this.accessCode.accessCodeDate = new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0) as any;
			}
			return;
		}
		if (v instanceof Date) {
			return;
		}
		this.accessCode.accessCodeDate = moment(v).toDate();
	}
}
